const teamVehicles = [
  {
    teamId: "ec9cac9b-6b79-4d61-a9b5-0e6d93fc64d0",
    teamName: "TUIDefaultTeam",
    vehicles: [
      {
        vehicleId: "OOETA",
        vehicleType: "E195",
      },
      {
        vehicleId: "OOETB",
        vehicleType: "E195",
      },
      {
        vehicleId: "OOJAV",
        vehicleType: "B738",
      },
      {
        vehicleId: "OOJDL",
        vehicleType: "B787",
      },
      {
        vehicleId: "OOLOE",
        vehicleType: "B787",
      },
      {
        vehicleId: "OOTEA",
        vehicleType: "E190",
      },
    ],
  },
];

export const getTeamVehiclesRespAviation = (teamId) => {
  if (!teamId) {
    return teamVehicles;
  }

  const res = [];
  teamId.forEach((id) => {
    const team = teamVehicles.filter((team) => team.teamId === id);
    if (team && team.length > 0) {
      res.push(team[0]);
    }
  });
  return res;
};
